<template>
  <div>
    <div>
      <span class="selected_lable">日期选择：</span>
      <el-date-picker
        v-model="durationStart"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      -
      <el-date-picker
        v-model="durationEnd"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      &nbsp;
      &nbsp;
      选择医院：
      <el-select v-model="hospitalId" placeholder="请选择医院" @change="selectHospital">
        <el-option
          v-for="item in hospitalList"
          :key="item.hospitalId"
          :label="item.hospitalName"
          :value="item.hospitalId">
        </el-option>
      </el-select>
      &nbsp;
      &nbsp;
      总人数：{{total}} 人
    </div>
    <div>
      <div id="main" style="height: 640px">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import Global from "../Global";

export default {
  name: "PlaqueCountFour",
  props: {
    hospital: String,
    hospitals: Array
  },
  data () {
    return {
      myChart: null,
      qc1Data: [],
      qc2Data: [],
      qc3Data: [],
      isClear: false,
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      hospitalList: this.hospitals,
      hospitalId: this.hospital,
      total: 0
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    // 选择医院
    selectHospital () {
      this.$emit('changeHospital', this.hospitalId)
      this.getAllData()
    },
    // 选择时间段
    durationChange () {
      this.getAllData()
    },
    async getAllData () {
      this.qc1Data = []
      this.qc2Data = []
      this.qc3Data = []
      // 获取各个年龄段的数据
      let data1 = await this.getData(0, 40)
      let data2 = await this.getData(41, 50)
      let data3 = await this.getData(51, 60)
      let data4 = await this.getData(61, 70)
      let data5 = await this.getData(71, 80)
      let data6 = await this.getData(81, 150)
      this.total = data1.total + data2.total + data3.total + data4.total + data5.total + data6.total
        // 放入一级病历数据
      this.qc1Data.push((data1.qc1 / this.total * 100).toFixed(2))
      this.qc1Data.push((data2.qc1 / this.total * 100).toFixed(2))
      this.qc1Data.push((data3.qc1 / this.total * 100).toFixed(2))
      this.qc1Data.push((data4.qc1 / this.total * 100).toFixed(2))
      this.qc1Data.push((data5.qc1 / this.total * 100).toFixed(2))
      this.qc1Data.push((data6.qc1 / this.total * 100).toFixed(2))
      // 放入二级病历数据
      this.qc2Data.push((data1.qc2 / this.total * 100).toFixed(2))
      this.qc2Data.push((data2.qc2 / this.total * 100).toFixed(2))
      this.qc2Data.push((data3.qc2 / this.total * 100).toFixed(2))
      this.qc2Data.push((data4.qc2 / this.total * 100).toFixed(2))
      this.qc2Data.push((data5.qc2 / this.total * 100).toFixed(2))
      this.qc2Data.push((data6.qc2 / this.total * 100).toFixed(2))
      // 放入三级病历数据
      this.qc3Data.push((data1.qc3 / this.total * 100).toFixed(2))
      this.qc3Data.push((data2.qc3 / this.total * 100).toFixed(2))
      this.qc3Data.push((data3.qc3 / this.total * 100).toFixed(2))
      this.qc3Data.push((data4.qc3 / this.total * 100).toFixed(2))
      this.qc3Data.push((data5.qc3 / this.total * 100).toFixed(2))
      this.qc3Data.push((data6.qc3 / this.total * 100).toFixed(2))
      this.initChart()
    },
    // 获取数据
    async getData (startAge, endAge) {
      let durationStart = this.durationStart.getTime()
      let durationEnd = this.durationEnd.getTime() + 1000 * 60 * 60 * 24
      if (durationStart > durationEnd) {
        this.$message.error('结束时间不能小于开始时间')
        return
      }
      let that = this
      let resp = await this.axios({
        method: 'GET',
        url: Global.yunyingUrl + '/service-order/order/countOrderLevelAll?durationStart=' + durationStart + '&durationEnd=' +
          durationEnd + '&hospitalId=' + that.hospitalId + '&startAge=' + startAge + '&endAge=' + endAge + '&sex=-1'
      })
      if (resp.data.code === 1000) {
        return resp.data.data
      }
    },
    // 初始化图表
    initChart () {
      // 如果存在实例需要进行销毁
      if (this.myChart != null) {
        this.myChart.dispose()
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById('main'))

      // 指定图表的配置项和数据
      let option = {
        title: {
          text: '斑块阳性分布病患线形图',
          left: 600
        },
        legend: {
          top: '5%',
          right: '0%',
          orient: 'vertical'
        },
        xAxis: {
          type: 'category',
          data: ['0-40岁', '40-50岁', '50-60岁', '60-70岁', '70-80岁', '80岁以上']
        },
        yAxis: {
          name: '阳性率（单位：%)'
        },
        series: [
          {
            name: '一级质控',
            data: this.qc1Data,
            type: 'line',
            color: '#00CDCD',
            // stack: 'x',
            label: {
              show: true,
              formatter: function (params) {
                if (params.value == 0) {  //为0时不显示
                  return ''
                } else {
                  return params.value + '%'
                }
              },
              fontWeight: 'bold'
            }
          },
          {
            name: '二级质控',
            data: this.qc2Data,
            type: 'line',
            color: '#CD853F',
            // stack: 'x',
            label: {
              show: true,
              formatter: function (params) {
                if (params.value == 0) {  //为0时不显示
                  return ''
                } else {
                  return params.value + '%'
                }
              },
              fontWeight: 'bold'
            }
          },
          {
            name: '三级质控',
            data: this.qc3Data,
            type: 'line',
            color: '#8B475D',
            // stack: 'x',
            label: {
              show: true,
              formatter: function (params) {
                if (params.value == 0) {  //为0时不显示
                  return ''
                } else {
                  return params.value + '%'
                }
              },
              fontWeight: 'bold'
            }
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/plaque_count/PlaqueCountFour.vue